import { Provider, useDispatch } from "react-redux";
import "../styles/globals.css";
import "../styles/Left-Right-Common-Block.css";
import "../styles/Layman-Explanation-Block.css";
import "../styles/Ontology-Of-Being.css"
import "../styles/Bio-of-Eddie.css"
import "../styles/Divine-Manifestation.css"
import "../styles/The-Persona.css"
import "../styles/Diviner-Academy.css"

import dynamic from "next/dynamic";
import store from "../redux/store";
import App from "next/app";
import cookies from "next-cookies";
import React, { useEffect } from "react";
import { updateProductCount } from "../redux/fetcher/TarrotCardSlice";
import { getCookie, setCookie } from "../components/utils/cookie";
import Head from 'next/head';
import BackgroundTask from "../components/BackgroundTask/BackgroundTask";


const Layout = dynamic(() => import("../components/Layout"));
const Loader = dynamic(() =>
  import("../components/PageLoader").then((mod) => mod.Loader)
);
function MyApp({ Component, pageProps, globalData ,isNoIndex}) {
//   useEffect(() => {
//     console.log("isNoIndex", isNoIndex);

// }, [isNoIndex]);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const count = globalData?.results?.res?.reduce(
        (accumulator, currentValue) => accumulator + currentValue.quantity,
        0
      );
      localStorage.setItem('cartCount', parseInt(count));

    }
  }, [globalData]);


  return (
    <Provider store={store}>
      
      <Layout>
        <Loader />
        <BackgroundTask />
        <Component {...pageProps} />
      </Layout>
    </Provider>
  );
}

MyApp.getInitialProps = async (appContext) => {

  const cookie = getCookie("guest_id");
  console.log(cookie, "================>");
  if (!cookie) {
    const randomValue =
      Math.random().toString(36).substring(2, 16) +
      Math.random().toString(36).substring(2, 16);

    const expires = new Date();
    expires.setMonth(expires.getMonth() + 2);

    setCookie("guest_id", randomValue, { expires });
  }
  const appProps = await App.getInitialProps(appContext);


  const allCookies = cookies(appContext.ctx);
  const cookieValue = allCookies.user_id || allCookies.guest_id;


  let obj = {
    searchcondition: {
      user_id: cookieValue,
    },
    sort: {
      type: "asc",
      field: "priority",
    },
  };

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...obj }),
  };

  // let globalData = await fetch(
  //   `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/cart-user-list`,
  //   requestOptions
  // );
  // globalData = await globalData.json();
  // console.log("globalData============>", globalData);

  return { ...appProps,  cookies };
};

export default MyApp;


App.getInitialProps = async ({ ctx }) => {
  const hostname = ctx.req ? ctx.req.headers.host : window.location.hostname;
  const isNoIndex = hostname == 'divineinfinitebeing.com';

  return { isNoIndex };
};
